$(document).ready(function(){

  var s_firmenname = localStorage.getItem('Firmenname');
  var s_eori_num = localStorage.getItem('eori_num');
  
  console.log('eori',s_firmenname,s_eori_num);
  /*
  if(s_firmenname && s_eori_num){
     $(".product-form__main_submit_btn").removeClass('hidden');
     $(".product-form__firm_button").addClass('hidden');

     let cart_page = $('.template-cart').length;      
     if(cart_page > 0) {
        $("#attr_Firmenname").val(s_firmenname);
        $("#attr_EORI").val(s_eori_num);
     }
  }else{
    $('.dynamic-checkout__content').remove();
  }*/

  /*
  $(document).on('click','.cart__checkout-button',function(){
    if(!s_firmenname && !s_eori_num){
      event.preventDefault();
      $('#cart-errors').html('<span class="error">Firmenname und EORI-Nummer sind obligatorisch. Bitte legen Sie das Produkt erneut in den Warenkorb, um fortzufahren.</span>');
    }
  })*/
  
  $(document).on('click','.list-menu li .list-menu__item[aria-expanded]',function(){
    var $this =  $(this);
	$this.parent('details').parent('li').siblings('li').find("details").removeAttr('open');
//     $this.parent('details').attr('open','open');
  });
  
  $('summary.header__menu-item, ul.header__submenu').hover(function(){
    $('summary.header__menu-item').parent('details').removeAttr('open');
    $(this).parent('details').attr('open','open');
  });
  
//   $('ul.header__submenu').hover(function(){
//     $('summary.header__menu-item').parent('details').removeAttr('open');
//     $(this).parent('details').attr('open','open');
//   });
  
  $('summary.header__menu-item, ul.header__submenu').mouseleave(function(){
    $(this).parent('details').removeAttr('open');
  });
  
  $('.site-weglot').hover(function(){
    $('.weglot_switcher.wg-drop').trigger('click');
  });

});



settings = {
  //Model Popup
  objModalPopupBtn: ".modalButton",
  objModalCloseBtn: ".overlay, .closeBtn",
  objModalDataAttr: "data-popup"
}  

$(document).on('click',settings.objModalPopupBtn,function(){
   if ($(this).attr(settings.objModalDataAttr)) {

    var strDataPopupName = $(this).attr(settings.objModalDataAttr);


    //Fade In Modal Pop Up
    $(".overlay, #" + strDataPopupName).fadeIn();

  }
});

//On clicking the modal background
$(document).on('click',settings.objModalCloseBtn,function(){
    $(".modal").fadeOut();
});

// Disable Popup
/*
$(document).on('click','.firm_popup_submit_button',function(){  
       
     var Firmenname_val = $('#firm_Firmenname').val();
     if(Firmenname_val){
       localStorage.setItem("Firmenname", Firmenname_val);
       $('.firm_Firmenname_error').hide();
     } else {
        $('.firm_Firmenname_error').show();
        return false;
     }
     var eori_num_val = $('#firm_eori_num').val();
     if(eori_num_val){
        localStorage.setItem("eori_num", eori_num_val);
        $('.firm_eori_nume_error').hide();
     } else {
        $('.firm_eori_nume_error').show();
        return false;
     }

     if(Firmenname_val && eori_num_val){ 
        $(".modal").fadeOut();
        $(".product-form__main_submit_btn").removeClass('hidden');
        $(".product-form__firm_button").addClass('hidden');
        $('.product-form__main_submit_btn').trigger('click');
        //console.log('Firmenname',$.session.get("Firmenname"));
     } 
  
});
*/

$(document).ready(function(){
  $('.content-main #tabify-3 a').attr('target', '_blank');
});